export enum ScoopfreeActivityType {
  SHOW_ALL = 'Show All',
  CUST_VIEW = "Customer's View",
  DISCONNECT = 'Disconnects',
  ERROR = 'Errors',
  FOOD_STATUS = 'Food Status',
  FEEDER_STATUS = 'Feeder Status',
  MEALS = 'Meals',
  ONLINE = 'Online',
  RAKE_NOW = 'Rake Now',
  RAKE_MOVING_FORWARD = 'Rake Moving Forward',
  RAKE_STOPPED = 'Rake Stopped',
  REVERSE_RAKE = 'Reverse Rake',
  RAKE_MOVING_BACK = 'Rake Moving Back',
  RAKE_FINISHED = 'Rake Finished',
  REBOOTING = 'Rebooting',
  RESET_TO_FACTORY_DEFAULTS = 'Reset to factory defaults',
  LAST_WILL = 'Last will',
  RAKE_BUTTON_DETECTED = 'Rake Button Detected',
  ERROR_RAKE_MOTOR_INTERRUPT = 'Error Rake Motor Interrupt',
  RAKE_PAUSED_MOTOR_CURRENT = 'Rake Paused Motor Current',
  RAKE_RESUME_MOTOR_CURRENT = 'Rake Resule Motor Current',
  CAT_IN_BOX = 'Cat detected in ScoopFree',
  CAT_LEFT_BOX = 'Cat detected leaving ScoopFree',
  RAKE_TIMER_EXPIRED = 'Rake timer expired',
  RAKE_COUNTER_RESET = 'Rake counter reset',
  RAKE_PAUSED_MANUAL = 'Rake paused manual',
  RAKE_RESUME_MANUAL = 'Rake resume manual',
  RAKE_PAUSE_CAT_ENTERED_BOX = 'Rake pause cat entered box',
  RAKE_RESUME_CAT_EXIT = 'Rake resume cat exit',
  FATAL_ERROR_MOTOR_SAFETY = 'Fatal error motor safety',
  RESET_WIFI_NETWORK = 'Reset wifi network',
  FATAL_ERROR_MOTOR_OVERCURRENT = 'Fatal error motor overcurrent',
  NO_CONDITIONS_TO_RESUME = 'No conditions to resume',
  MOTION_DETECTED_INSIDE = 'Motion detected Inside',
  MOTION_DETECTED_OUTSIDE = 'Motion detected Outside',
  MOTION_ABSENT_OUTSIDE = 'Motion absent Outside',
  MOTION_ABSENT_INSIDE = 'Motion absent Inside',
  MOTION_ABSENT_OUTSIDE_FALSE_TRIGGER = 'Motion absent Outside (False Trigger)',
  MOTION_ABSENT_INSIDE_FALSE_TRIGGER = 'Motion absent Inside (False Trigger)',
  RFID_READ_INSIDE = 'RFID Read Inside',
  RFID_READ_OUTSIDE = 'RFID Read Outside',
  ACCESS_PERMISSION_LOOKUP = 'Access permission Lookup',
  SCHEDULE_EVENT = 'Schedule Event',
  OVERRIDE = 'Override',
  UNKNOWN_RFID = 'Unknown RFID',
  SCHEDULES_NOT_FOUND = 'Schedules Not Found',
  TIME_NOT_SET = 'Time not set',
  NO_SCHEDULES_ATTACHED_TO_RFID = 'No Schedules attached to RFID',
  INVALID_SCHEDULE = 'Invalid Schedule',
  LATCH_LOCKED = 'Latch Locked',
  LATCH_UNLOCKED = 'Latch Unlocked',
  LATCH_IN_ONLY = 'Latch in only',
  LATCH_OUT_ONLY = 'Latch out only',
  FLAP_SWING_IN = 'Flap Swing In',
  FLAP_SWING_OUT = 'Flap swing out',
  FLAP_SWING_TIMEOUT = 'Flap swing timeout',
  FLAP_CENTERED = 'Flap centered',
  PET_ENTERED = 'Pet Entered',
  PET_EXITED = 'Pet Exited',
  PET_FAILED_TO_TRANSIT_DOOR_RELOCKED = 'Pet Failed to Transit Door Relocked',
  USER_MODE_CHANGE_SMART = 'User Mode Change Smart',
  USER_MODE_CHANGE_LOCKED = 'User Mode Change Locked',
  USER_MODE_CHANGE_UNLOCKED = 'User Mode Change Unlocked',
  USER_DISABLED_FRONT_PANEL = 'User Disabled Front Panel',
  USER_WIFI_SOFT_REBOOT = 'User WIFI Soft Reboot',
  USER_WIFI_PROVISIONING_RESET = 'User WIFI provisioning reset',
  USER_FACTORY_RESET = 'User Factory Reset',
  USER_BUTTONS_LOCKED_ENABLED = 'User Buttons Locked Enabled',
  USER_BUTTONS_LOCKED_DISABLED = 'User Buttons Locked Disabled',
  CLOUD_MODE_CHANGE_SMART = 'Cloud Mode Change Smart',
  CLOUD_MODE_CHANGE_LOCKED = 'Cloud Mode Change Locked',
  CLOUD_MODE_CHANGE_UNLOCKED = 'Cloud Mode Change Unlocked',
  CLOUD_BUTTONS_LOCKED_ENABLED = 'Cloud Buttons Locked Enabled',
  CLOUD_BUTTONS_LOCKED_DISABLED = 'Cloud Buttons Locked Disabled',
  DISPLAY_ON = 'Display On',
  DISPLAY_OFF = 'Display Off',
  ERROR_MOTOR_OVERCURRENT = 'Error Motor Overcurrent',
  ERROR_MOTOR_TIMEOUT = 'Error Motor Timeout',
  ERROR_FLAP_TIMEOUT = 'Error Flap Timeout',
  ERROR_FLAP_STUCK = 'Error Flap Stuck',
  ERROR_INSIDE_MOTION_SENSOR_CONTINUOUS = 'Error Inside motion sensor continuous',
  ERROR_OUTSIDE_MOTION_SENSOR_CONTINUOUS = 'Error Outside motion sensor continuous',
  ERROR_BUTTON_STUCK = 'Error Button Stuck',
  ERROR_LATCH_POSITION_SENSOR = 'Error Latch Position Sensor',
  ERROR_VOLTAGE_READING_OUT_OF_RANGE = 'Error Voltage Reading Out of Range',
  RTC_TIME_UPDATE = 'RTC Time Update',
  POWER_FAIL_MODE = 'Power Fail Mode',
  BATTERY_LEVEL_THRESHOLD = 'Battery Level Threshold',
  POWER_AC_LOST = 'Power AC Lost',
  POWER_AC_RESTORED = 'Power AC Restored',
  POWER_AC_NO_BATTERIES = 'Power AC No Batteries',
  ENTERED_FINAL_ACT_STATE = 'Entered Final Act State',
  OTA_WAITING_JOB_START = 'OTA Waiting Job Start',
  OTA_JOB_STARTED = 'OTA Job Started',
  OTA_BLOCK_RECEIVED = 'OTA Block Received',
  OTA_ALL_BLOCKS_RECEIVED = 'OTA All Blocks Received',
  OTA_IMAGE_VERIFIED = 'OTA Timage Verified',
}
